module.exports = __webpack_public_path__ + "img/aeroland-feature-icon-image.a3663546.png";